export default __webpack_public_path__ + "static/media/alert-triangle.db79fce3.svg";